import React from 'react';

const IsMobileContext = React.createContext(true);

export default IsMobileContext;
